import { addYears } from 'date-fns';
import React from 'react';

import {
  CmDatePicker,
  CmFlex,
  CmFormControl,
  CmFormLabel,
  CmText,
} from '@/components/uiParts';

interface Props {
  label: string;
  startDate: Date;
  endDate: Date;
  setStartDate: (date: Date) => void;
  setEndDate: (date: Date) => void;
  maxDate?: Date;
}

export const DateRangeFormControl: React.VFC<Props> = ({
  label,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  // 最大範囲を1年に制限
  const maxStartDate = addYears(endDate, -1);
  const maxEndDate = addYears(startDate, 1);
  const today = new Date();
  // 現在から3年前までとする
  const minStartDate = addYears(today, -3);

  return (
    <CmFormControl width="auto">
      <CmFlex align="center">
        <CmFormLabel mr={2} mb={0}>
          {label}
        </CmFormLabel>
        <CmFlex align="center">
          <CmDatePicker
            selected={startDate}
            onChange={setStartDate}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            // 最小値はendDateから1年前、ただし現在より3年前より前にはできない
            minDate={maxStartDate < minStartDate ? minStartDate : maxStartDate}
            // 最大値はendDateと今日のうち早い方
            maxDate={endDate < today ? endDate : today}
          />
          <CmText mx={2}>〜</CmText>
          <CmDatePicker
            selected={endDate}
            onChange={setEndDate}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            // 最小値はstartDate
            minDate={startDate}
            // 最大値はmaxEndDateと今日のうち早い方
            maxDate={maxEndDate < today ? maxEndDate : today}
          />
        </CmFlex>
      </CmFlex>
    </CmFormControl>
  );
};
